import httpService from '@/services/httpService';
import ApiEndpoints from '@/utils/ApiEndpoints';

export default {
    searchSuggest (data, isQualified) {
        const endpoint = isQualified ? 'search_suggest_qualified' : 'search';
        return httpService.post(
            ApiEndpoints.getWithURLParams(endpoint, { urlParams: data.queryString }),
            data.params
        );
    },
    filtersResources (id) {
        return httpService.get(ApiEndpoints.get('filters_resources', { pageId: id }));
    },
    getFilterID (payload) {
        return httpService.post(ApiEndpoints.get('search'), payload);
    },
    getRegionsPerProvince (id) {
        return httpService.get(ApiEndpoints.get('rejon_per_province', { provinceId: id }));
    },
    getVolunteersPerRegion (id) {
        return httpService.get(ApiEndpoints.get('volunteers_per_region', { locationId: id }));
    },
    sendFiltersQualifiedParams (data) {
        return httpService.post(ApiEndpoints.getWithURLParams('my_families', data.params), data.data);
    },
    sendFiltersToAcceptParams (data) {
        return httpService.post(
            ApiEndpoints.getWithURLParams('families_unallocated', data.params),
            data.data
        );
    }
};
